export default function PopularIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 -3.5 27 27"
      fill="none"
    >
      <g filter="url(#filter0_d_1843_21538)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.178 9.9439C13.1697 10.0032 12.5932 14.0882 10.9104 16.2554C10.7926 16.4357 10.656 16.609 10.4993 16.7701C9.29422 18.0073 7.39547 18.1139 6.25903 17.0084C5.12265 15.9023 5.17785 14.0017 6.38305 12.7642C6.65768 12.4824 6.9707 12.2627 7.30004 12.0992C9.49398 10.5643 13.1308 9.95178 13.178 9.9439ZM13.4534 9.93707C13.4589 9.93783 17.1591 10.4529 19.4045 11.9459C19.734 12.1002 20.0476 12.3112 20.3264 12.5826C21.564 13.7873 21.6708 15.6849 20.5647 16.8209C19.4583 17.9563 17.5582 17.9002 16.3206 16.6959C16.1591 16.5387 16.0166 16.3695 15.8938 16.1919C14.1468 14.0681 13.4607 9.9811 13.4534 9.93707ZM16.1497 2.77984C17.3548 1.54265 19.2525 1.43583 20.3889 2.54156C21.5253 3.64761 21.4691 5.54728 20.2639 6.78472C20.1074 6.94535 19.9396 7.0872 19.7629 7.20953C17.6413 8.95686 13.553 9.64344 13.5022 9.65191C13.509 9.60312 14.0278 5.92977 15.5149 3.69878C15.6691 3.37069 15.8791 3.05766 16.1497 2.77984ZM6.09692 2.7398C7.20322 1.60439 9.10335 1.6597 10.3411 2.86382C10.5044 3.02277 10.648 3.19484 10.7717 3.37457C12.5096 5.49348 13.1967 9.55374 13.2082 9.62261C13.1882 9.61982 9.49495 9.10408 7.25415 7.61285C6.92585 7.45868 6.6122 7.24862 6.33422 6.97808C5.09688 5.77327 4.99073 3.87566 6.09692 2.7398Z"
          fill="url(#paint0_radial_1843_21538)"
        />
      </g>
      <ellipse
        cx="13.324"
        cy="9.79086"
        rx="0.179486"
        ry="4.53695"
        fill="url(#paint1_radial_1843_21538)"
      />
      <ellipse
        cx="13.2962"
        cy="9.78932"
        rx="0.179427"
        ry="4.53844"
        transform="rotate(-90 13.2962 9.78932)"
        fill="url(#paint2_radial_1843_21538)"
      />
      <defs>
        <filter
          id="filter0_d_1843_21538"
          x="-0.00130224"
          y="-0.00043416"
          width="26.6628"
          height="26.6628"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.55556" />
          <feGaussianBlur stdDeviation="2.66667" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1843_21538"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1843_21538"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_1843_21538"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.3306 9.77494) rotate(90) scale(26.8227 26.8261)"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#A5D6FD" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1843_21538"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.324 9.79086) rotate(90) scale(4.53695 0.179486)"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_1843_21538"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.2962 9.78932) rotate(90) scale(4.53844 0.179427)"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}
